import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/ _createElementVNode("hr")
], -1);
const _hoisted_2 = {
    key: 1,
    class: "mb-3 error__message-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_form = _resolveComponent("g-form");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: _ctx.$tc('client.identity.changeUserName.Title')
    }, {
        "modal-footer": _withCtx(() => [
            (_ctx._step === 2)
                ? (_openBlock(), _createBlock(_component_g_button, {
                    key: 0,
                    text: _ctx.$tc('shared.Text.Back'),
                    onClick: _withModifiers(_ctx.onBack, ["stop", "prevent"]),
                    type: "normal",
                    class: "w-120-px me-auto"
                }, null, 8, ["text", "onClick"]))
                : _createCommentVNode("", true),
            _createVNode(_component_g_button, {
                text: _ctx._step === 1 ? _ctx.$tc('shared.Text.Next') : _ctx.$tc('client.identity.changeUserName.CommandChange'),
                "is-loading": _ctx._isLoading,
                onClick: _ctx.onNext,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["text", "is-loading", "onClick"]),
            _createVNode(_component_g_button, {
                text: _ctx.$tc('shared.Text.Cancel'),
                onClick: _ctx.currentWindow.close,
                type: "normal",
                class: "w-120-px",
                "button-style": "btn-secondary"
            }, null, 8, ["text", "onClick"])
        ]),
        default: _withCtx(() => [
            _createVNode(_component_g_form, {
                ref: "frmMain",
                "data-object": _ctx.$data
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_g_text_field, {
                        label: _ctx.$tc('client.identity.changeUserName.CurrentUserName'),
                        "data-mode": "model",
                        "show-label": true,
                        "data-object": _ctx.$data,
                        "data-member": "_oldUserName",
                        "read-only": true,
                        "validation-rules": { required: true }
                    }, null, 8, ["label", "data-object"]),
                    _createVNode(_component_g_text_field, {
                        label: _ctx.$tc('client.identity.changeUserName.NewUserName') + '*',
                        "data-mode": "model",
                        "show-label": true,
                        "data-object": _ctx.$data,
                        "data-member": "_newUserName",
                        "read-only": _ctx._step > 1,
                        "validation-rules": { required: true, type: 'email', notequals: '_oldUserName' }
                    }, null, 8, ["label", "data-object", "read-only"]),
                    (_ctx._step === 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_1,
                            _createVNode(_component_g_text_field, {
                                "data-object": _ctx.$data,
                                "data-member": "_code",
                                "data-mode": "model",
                                label: _ctx.$tc('account.ActivationCodeWithNotes'),
                                "validation-rules": { required: true },
                                mode: "text",
                                "show-clear-button": false
                            }, null, 8, ["data-object", "label"])
                        ], 64))
                        : _createCommentVNode("", true),
                    (_ctx._errorMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx._errorMessage), 1))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["data-object"])
        ]),
        _: 1
    }, 8, ["title"]));
}
